import {
  CompanyPlaybackEarlyReportMutationInput,
  useRequestCompanyPlaybackEarlyReportMutation,
} from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

const useRequestCompanyPlaybackEarlyReport = () => {
  const [mutation, mutationResult] = useRequestCompanyPlaybackEarlyReportMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: CompanyPlaybackEarlyReportMutationInput) => {
    const mutationResult = await mutation({
      variables: {
        input: {
          ...input,
        },
      },
    });
    return mutationResult.data?.result?.ok || undefined;
  };

  const result = {
    error: mutationResult.error,
    loading: mutationResult.loading,
  };

  return { request, result };
};

export default useRequestCompanyPlaybackEarlyReport;
